import { render, staticRenderFns } from "./SubmitalHeader.vue?vue&type=template&id=fc4c6d94&scoped=true&"
import script from "./SubmitalHeader.vue?vue&type=script&lang=js&"
export * from "./SubmitalHeader.vue?vue&type=script&lang=js&"
import style0 from "./SubmitalHeader.vue?vue&type=style&index=0&id=fc4c6d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4c6d94",
  null
  
)

export default component.exports